import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { EmployeeService } from '../../employee/employee.service';
import { functionpermission, GetTaxListBO, saveTaxBO } from '../taxs-details.modal';
import { TDService } from './taxs.service';
import { TaskDateService } from './taxsdateservice';

@Component({
  selector: 'app-taxs',
  templateUrl: './taxs.component.html',
  styleUrls: ['./taxs.component.scss']
})

export class TaxsComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridTax') public gridTax: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  isSaveorUpdateBoolean:boolean=false;
  saveTaxInfo: saveTaxBO = new saveTaxBO();
  TaxFilterBo: GetTaxListBO = new GetTaxListBO();
  fp: functionpermission = new functionpermission()

  constructor(public DateService: TaskDateService,
    public service: TDService, public employee: EmployeeService,
    public global: GlobalComponent, public toasterservice: ToastrService) {

    this.GridList = DateService;
  }

  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.TaxFilterBo.field = "name";
    this.TaxFilterBo.orderColumn = "name";
    this.getTaxFilter();
  }

  // ................................................dataChangeTax..............................................
  public dataChangeTax(RL): void {
    let val = (RL.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((RL.sorted || []).length) {
        this.TaxFilterBo.orderColumn = RL.sorted[0].name;
        this.TaxFilterBo.orderType = RL.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && RL.action.action != "clearFilter") {
      this.TaxFilterBo.value = RL.action.currentFilterObject.value;
      this.TaxFilterBo.field = RL.action.currentFilterObject.field;
      this.TaxFilterBo.matchCase = RL.action.currentFilterObject.matchCase;
      this.TaxFilterBo.operator = RL.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && RL.action.action == "clearFilter") {
        this.TaxFilterBo.field = "name";
        this.TaxFilterBo.matchCase = false;
        this.TaxFilterBo.operator = "contains";
        this.TaxFilterBo.value = "";
        this.TaxFilterBo.type = "string";
      }
    }
    this.getTaxFilter();
    if (val == "paging" && RL.action.name == "actionBegin") {

    }
  }
  //.........................................onActionTAx.....................................................
  public onActionTAx(RL) {
    this.TaxFilterBo.currentpageno = this.gridTax.pagerModule.pagerObj.currentPage;
    this.TaxFilterBo.pageitem = this.gridTax.pagerModule.pagerObj.pageSize;
    if (RL.name == "actionBegin" && RL.requestType == "filterbeforeopen") {
      this.TaxFilterBo.type = RL.columnType
    }
  }
  //...........................................getDetails..........................................
  getDetails(saveBos: saveTaxBO) {
    this.saveTaxInfo = JSON.parse(JSON.stringify(saveBos));
  }
  //............................................Refresh...................................................
  Refresh() {
    this.saveTaxInfo = new saveTaxBO();
    this.TaxFilterBo = new GetTaxListBO();
    this.getTaxFilter();
  }

  //.........................................getTaxFilter.............................................
  getTaxFilter() {
    this.DateService.execute(this.TaxFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridTax.height = '500';
      }
      else {
        this.gridTax.height = 'auto';
      }
    })
  }
  //.........................................SaveOrUpdateTaxList.............................................
  SaveOrUpdateTaxList() {
    this.isSaveorUpdateBoolean=true;
    let savepayload: saveTaxBO = JSON.parse(JSON.stringify(this.saveTaxInfo));
    savepayload.id = this.saveTaxInfo.id;
    this.service.saveTax(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      document.getElementById('openTaxModal').click();
      if (data) {
        if (this.saveTaxInfo.id == '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Tax saved successfully!');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);

        }
        else if (this.saveTaxInfo.id != '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Tax updated successfully!');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        }
        document.getElementById('openTaxModal').click();
        this.saveTaxInfo = new saveTaxBO();
        this.getTaxFilter();
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }

  showTaxColumns() {
    this.gridTax.columnChooserModule.openColumnChooser(200, 50);
  }
  //..........................................DeleteTax...........................................................
  DeleteTax() {
    let params = new URLSearchParams();
    params.append("Id", this.saveTaxInfo.id);
    this.service.DeleteTax(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterservice.success('Tax deleted successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      document.getElementById('closeTaxModal').click();
      this.getTaxFilter();
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  clearTax() {
    this.saveTaxInfo = new saveTaxBO();
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

